import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import InvoiceCard from './InvoiceCard';
import Illustration from '../../Illustration';
import InvoiceDueCard from './InvoiceDueCard';

import {
  selectInvoiceList,
  selectProjectInvoices,
} from '../../../store/selectors';

const styles = theme => ({
  root: {
  },

});

const InvoiceCards = ({ classes, invoices, project }) => {

  return (
    <div className={classes.root}>
      {invoices.length > 0 &&
          invoices.map((invoice, i) => {
            if (invoice.id) {
              return <InvoiceCard key={i} invoice={invoice} />
            } else {
              return <InvoiceDueCard key={i} invoice={invoice} />
            }

          })

      }
      {invoices.length === 0 &&
        <Illustration
          title="Hmm, no Invoices..."
          imgKey="printing_invoices_amber"
          explainerText="Either you've not entered any or your filter had no results."
          addItemText="Enter a new Invoice by clicking the 'Floating Action Button' at top right."
        />
      }
    </div>

  );
};

const mapStateToProps = (state, props) => {
  const { project } = props;
  const invoices = project
    ? selectProjectInvoices(state, project)
    : selectInvoiceList(state, project);

  return ({
    invoices
  });
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(InvoiceCards);



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/InvoiceCards.jsx